import {ProcessExecutionType} from 'graphql-client/__generated/graphqlGlobalTypes';

/**
 * Checks if a task schema is a flowchart task schema.
 */
export function isFlowchartTaskSchema(taskSchema: {executionType: ProcessExecutionType}): boolean {
  return [ProcessExecutionType.FLOWCHART, ProcessExecutionType.PROCEDURE].includes(taskSchema.executionType);
}
